<template>
  <section v-if="locations?.length" class="accommodations defaultSectionMargins" :class="{ 'accommodations--Brand': isBrand }">
    <div class="container">
      <h2 v-text="data.title" />

      <p v-if="data.description" class="accommodations__Description">{{ data.description }}</p>
  
      <div class="accommodations__List">
        <SimilarAccommodationsSlider :locations="locations" :flickityOptions="flickityOptions" />
      </div>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  });
  const { page } = usePage();
  const { accommodationsData } = useSetup();

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };

  const isBrand = computed(() => page.value.meta.type.includes('BrandDetail'));
  const locations = computed(() => {
    if (page.value?.accommodations?.length) {
      let accommodationsList = [];
      for (const item of page.value.accommodations) {
        if (accommodationsData.value[item]) accommodationsList.push(accommodationsData.value[item]);
      }
      return accommodationsList;
    } else {
      return Object.values(accommodationsData.value).filter(item => {
        if (isBrand.value) return item.brand_id === page.value.id;
        return item.place.name === page.value.name
      })
    }
  });
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_accommodations.scss');
</style>